import * as _ from 'lodash';

import { ITreeConfiguration, Category, Dashboard, ITreeItem } from '../../models/index';
import { guidEmpty } from '../../common';

export function buildDashboardsTree(subState: string, categories: Category[], dashboards: Dashboard[]): ITreeConfiguration {
    const configuration: ITreeConfiguration = {
        items: [],
        url: subState,
        urlParams: ''
    };
    const items: (ITreeItem & (Category | Dashboard))[] = [];

    const allCategories: any[] = categories;
    const allDashboards: any[] = dashboards;

    if (allDashboards && allDashboards.length > 0) {
        // First => Dashboards which have no categories
        let categorylessDashboards: (ITreeItem & Dashboard)[] = allDashboards.filter(d => d.categories.length === 0);
        categorylessDashboards = _.sortBy(categorylessDashboards, d => d.sortOrder);
        categorylessDashboards.forEach(dashboard => {
            dashboard.depth = 1;
            dashboard.isVisible = true;
            dashboard.title = dashboard.name;
            dashboard.itemType = 'Dashboard';
            dashboard.uniqueId = dashboard.guid;
            dashboard.url = configuration.url;

            // Add category-less dashboard to the items to be displayed
            items.push(dashboard);
        });

        // Second => Categories at first level which are linked to at least one dashboard
        const dashboardsWithCategories: (ITreeItem & Dashboard)[] = allDashboards.filter(d => d.categories.length > 0);
        const categoriesGuidLinkedToDashboards: string[] = _.flatten(dashboardsWithCategories.map(d => d.categories));
        let categoriesLinkedToDashboards: (ITreeItem & Category)[] = allCategories.filter(c => categoriesGuidLinkedToDashboards.indexOf(c.guid) >= 0);

        categoriesLinkedToDashboards = _.sortBy(categoriesLinkedToDashboards, d => d.name);

        // Third => Dashboards depending on each category at second level
        categoriesLinkedToDashboards.forEach(category => {
            const children: (ITreeItem & (Category | Dashboard))[] = allDashboards.filter(d => d.categories.indexOf(category.guid) >= 0);
            let categoryChildren: (ITreeItem & (Category | Dashboard))[] = [];

            // Add information to dashboards linked to a category
            // Clone to avoid overwriting allDashboards values
            // This fix an issue when a dashboard depends on multiple categories
            children.forEach(child => {
                const childDashboard: any = Dashboard.cloneWithoutConfiguration(child as Dashboard);
                childDashboard.depth = 2;
                childDashboard.isVisible = true;
                childDashboard.title = child.name;
                childDashboard.itemType = 'Dashboard';
                childDashboard.children = null;
                childDashboard.parentGUID = category.guid;
                childDashboard.uniqueId = category.name + child.name;
                childDashboard.url = configuration.url;
                categoryChildren.push(childDashboard);
            });

            categoryChildren = _.sortBy(categoryChildren, d => d.sortOrder);

            // Add information to category
            category.depth = 1;
            category.isVisible = true;
            category.title = category.name;
            category.children = [].concat(categoryChildren);
            category.itemType = 'Category';
            category.parentGUID = guidEmpty;
            category.uniqueId = category.guid;
            category.url = 'dashboards';

            // Add categories and their children to the items to be displayed
            items.push(category);
            categoryChildren.forEach(child => {
                items.push(child);
            });
        });

        configuration.items = items;
        configuration.urlParams = {
            dashboardName: (item: ITreeItem) => (item.itemType === 'Dashboard') ? item.guid : '',
            categoryGuid: (item: ITreeItem) => (item.itemType === 'Category') ? item.guid : ''
        };
    }
    return configuration;
}